import React from "react";
import { Box } from "@mui/material";

import Footer from "./Footer";
import Header from "./Header";

function AppShell({ children, hideHeader}) {
  return (
    <Box
      overflow="hidden"
      minHeight="100vh"
      display="flex"
      flexDirection="column"
    >
      {!hideHeader && <Header/>}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        minHeight={"calc(100vh - 80px)"}
      >
        {children}
      </Box>
      <Footer/>
    </Box>
  );
}

export default AppShell;
